import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ContentHeader from "../../../../shared/content-header/content-header.component";
import TestMainTableComponent from "./test-main-table.component";
import TableSort from "../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../shared/helpers/upper-case";
import { useQuery } from "@tanstack/react-query";
import { getTests } from "../../../../core/api/services/test.service";

const TestMainComponent = () => {
  const [PageNumber, setPageNum] = useState<number>(1);
  const [filters, setFilters] = useState<any>({});
  const pageSize = 10;

  const filter = useSelector((state: any) => {
    return state.test.filter;
  });

  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("assetCode"));
  const [SortDirection, setSortDirection] = useState<any>("desc");

  const [columns, setColumns] = useState([
    {
      title: "Asset ID",
      label: "assetCode",
      isSorted: true,
    },
    {
      title: "Test Type",
      label: "testType",
      width: "8rem"
    },
    {
      title: "Functional Test Date & Time",
      label: "functionalTestDateTime",
      type: "datetime",
      width: "16rem"
    },
    {
      title: "Duration Test Date & Time",
      label: "durationTestDateTime",
      type: "datetime",
      width: "16rem"
    },
    {
      title: "Start Time",
      label: "startTime",
      type: "time",
      width: "10rem"
    },
    {
      title: "Status",
      label: "status",
    },
  ]);

  useEffect(() => {
    setFilters(filter);
  }, [filter]);

  const {
    data: tests,
    isLoading: isLoadingTests,
    refetch,
  } = useQuery({
    queryKey: [
      "getTests",
      PageNumber,
      filters?.townCouncil,
      filters?.site,
      filters?.block,
      filters?.testTypeId,
      filters?.testScheduleTypeId,
      SortBy,
      SortDirection,
    ],
    queryFn: ({ signal }) =>
      getTests(
        PageNumber,
        pageSize,
        filters?.townCouncil,
        filters?.site,
        filters?.block,
        filters?.testTypeId,
        filters?.testScheduleTypeId,
        SortBy,
        SortDirection,
        signal
      ),
  });

  const onRefetchData = () => {
    if (tests?.numberOfRecords <= pageSize + 1) {
      setPageNum(1);
    }
    refetch();
  };

  const handleChangePage = useCallback((page: number): void => {
    setPageNum(page);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  return (
    <div className="flex-col items-center justify-center">
      <div className="header-container">
        <div className="title-container">
          <ContentHeader pageTitle="Test" />
        </div>
      </div>
      <div className="page">
        <div className="page-container mt-4">
          <TestMainTableComponent
            columns={columns}
            data={tests?.data}
            totalNumberOfRecords={tests?.numberOfRecords}
            pageSize={pageSize}
            current={PageNumber}
            onChangePage={handleChangePage}
            onRefetchData={onRefetchData}
            onChangeSort={handleChangeSort}
            isLoading={isLoadingTests}
            filter={filter}
          />
        </div>
      </div>
    </div>
  );
};

export default TestMainComponent;
